/* ================================================================
   NOCTIQ — homepage.js
   ----------------------------------------------------------------
   1.  Scroll Reveal
   2.  Sticky Header
   3.  Mobile Menu
   4.  Hero Video Controls
   5.  Scroll Features (sticky scroll with fade panels)
   6.  Testimonial Slider
   7.  Mobile CTA Bar
   8.  Live Chat Widget
   9.  Broken Image Fallback
   ================================================================ */

(function () {
  "use strict";

  /* ================================================================
     1. SCROLL REVEAL
     Adds .visible to every .reveal element when it enters viewport.
     Above-the-fold elements fire immediately on load.
     ================================================================ */

  function initScrollReveal() {
    var elements = document.querySelectorAll(".reveal");
    if (!elements.length) return;

    if (!("IntersectionObserver" in window)) {
      elements.forEach(function (el) {
        el.classList.add("visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" },
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

 

  /* ================================================================
     4. HERO VIDEO CONTROLS
     ================================================================ */

  function initHeroVideo() {
    var video = document.querySelector(".hero__video");
    var playBtn = document.getElementById("hero-play-btn");
    var soundBtn = document.getElementById("hero-sound-btn");

    if (!video) return;

    if (playBtn) {
      playBtn.addEventListener("click", function () {
        if (video.paused) {
          video.play();
          playBtn.setAttribute("aria-label", "Pause background video");
          playBtn.querySelector("span").textContent = "⏸";
        } else {
          video.pause();
          playBtn.setAttribute("aria-label", "Play background video");
          playBtn.querySelector("span").textContent = "▶";
        }
      });
    }

    if (soundBtn) {
      soundBtn.addEventListener("click", function () {
        video.muted = !video.muted;
        soundBtn.setAttribute("aria-label", video.muted ? "Unmute video" : "Mute video");
        soundBtn.querySelector("span").textContent = video.muted ? "🔇" : "🔊";
      });
    }
  }

  /* ================================================================
     5. SCROLL FEATURES — sticky scroll with fade panels
     ----------------------------------------------------------------
     Desktop: section is position:sticky; scroll progress through
     .sf-spacer drives which panel (0-4) is active.
     Mobile: dots become manual navigation buttons.
     ================================================================ */

function initScrollFeatures() {
    var section = document.getElementById("features");
    var sticky = section && section.querySelector(".sf-sticky");
    var inner = section && section.querySelector(".sf-sticky__inner");
    var spacer = section && section.querySelector(".sf-spacer");
    var panels = document.querySelectorAll(".sf-panel");
    var images = document.querySelectorAll(".sf-image");
    var dots = document.querySelectorAll(".sf-nav__dot");
    var counter = document.getElementById("sf-counter-cur");

    if (!section || !sticky || !panels.length) return;

    var numPanels = panels.length;
    var activeIdx = 0;
    var sectionDocTop = 0;
    var total = 0;
    var stickyFixed = false; /* true only while position:fixed is active */
    var snapBusy = false;    /* prevents double-snap during smooth scroll */

    /* ---- shared setter ---- */
    function setActive(index) {
      index = Math.max(0, Math.min(numPanels - 1, index));
      if (index === activeIdx && panels[index].classList.contains("is-active")) return;
      activeIdx = index;

      var isMob = window.matchMedia("(max-width: 768px)").matches;
      panels.forEach(function (p, i) {
        var isAct = i === index;
        p.classList.toggle("is-active", isAct);
        /* On mobile: align panels to the top of the container (no vertical
           centering) so there is no empty gap below the content. */
        if (isMob) {
          p.style.top = "0";
          p.style.transform = isAct ? "translateY(0)" : "translateY(20px)";
        } else {
          p.style.top = "";
          p.style.transform = "";
        }
      });
      images.forEach(function (img, i) {
        img.classList.toggle("is-active", i === index);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle("is-active", i === index);
        d.setAttribute("aria-pressed", String(i === index));
      });

      if (counter) {
        counter.textContent = String(index + 1).padStart(2, "0");
      }
    }

    var sfImagesEl = section.querySelector(".sf-images");
    var sfPanelsEl = section.querySelector(".sf-panels");
    var sfNavEl = section.querySelector(".sf-nav");

    /* Apply column layout for mobile entirely via inline styles so CSS
       media-query reliability in Shopify is irrelevant. */
    function applyLayout() {
      var isMob = window.matchMedia("(max-width: 768px)").matches;
      if (isMob) {
        /* sticky__inner: column, full height — reserve 72px at bottom for nav */
        if (inner) inner.style.cssText = "display:flex;flex-direction:column;align-items:center;" + "height:100%;gap:16px;padding:20px 20px 72px;box-sizing:border-box;";
        /* image: relative (keeps containing block for abs children), pulled to top */
        if (sfImagesEl) sfImagesEl.style.cssText = "position:relative;height:200px;width:100%;flex-shrink:0;order:-1;";
        /* panels: fill remaining space — no height:auto or flex collapses to 0
           (all .sf-panel children are position:absolute so content height = 0) */
        if (sfPanelsEl) sfPanelsEl.style.cssText = "position:relative;flex:1;min-height:0;width:100%;";
        /* nav: absolute at bottom of sf-sticky (which has position:relative in CSS) */
        if (sfNavEl) sfNavEl.style.cssText = "position:absolute;top:auto;bottom:20px;left:0;right:0;display:flex;" + "flex-direction:row;justify-content:center;transform:none;padding:0;";
      } else {
        if (inner) inner.style.cssText = "";
        if (sfImagesEl) sfImagesEl.style.cssText = "";
        if (sfPanelsEl) sfPanelsEl.style.cssText = "";
        if (sfNavEl) sfNavEl.style.cssText = "";
      }
    }

    /* Capture section's document-top once (or on resize).
       Must be called with sticky un-fixed so getBoundingClientRect is accurate.
       Use px (window.innerHeight) — not vh — so section height and total stay
       in the same unit. vh ≠ window.innerHeight on iOS/Android Chrome. */
    function recalc() {
      sticky.style.cssText = "";
      if (spacer) spacer.style.display = "";
      var vh = window.innerHeight;
      section.style.height = numPanels * vh + "px";
      applyLayout();
      sectionDocTop = section.getBoundingClientRect().top + window.scrollY;
      total = (numPanels - 1) * vh;
    }

    /* ---- JS pin — all screen sizes ---- */
    function onScroll() {
      var scrolled = window.scrollY - sectionDocTop;
      var sectionRect;

      if (scrolled <= 0) {
        stickyFixed = false;
        sticky.style.cssText = "";
        setActive(0);
      } else if (scrolled >= total) {
        stickyFixed = false;
        /* Slide the sticky UP as the user scrolls past the last panel so the
           next section rises from below — no empty background gap visible. */
        var extra = scrolled - total;
        sectionRect = section.getBoundingClientRect();
        sticky.style.cssText = "position:fixed;top:0;left:" + sectionRect.left + "px;" + "width:" + sectionRect.width + "px;height:" + window.innerHeight + "px;" + "transform:translateY(-" + extra + "px);z-index:1;";
        setActive(numPanels - 1);
      } else {
        stickyFixed = true;
        sectionRect = section.getBoundingClientRect();
        sticky.style.cssText = "position:fixed;top:0;left:" + sectionRect.left + "px;" + "width:" + sectionRect.width + "px;height:" + window.innerHeight + "px;z-index:1;";
        setActive(Math.floor((scrolled / total) * numPanels));
      }
    }

    setActive(0); /* initialize first panel on all screen sizes */
    recalc();
    onScroll();

    /* Shopify layout settles after load — recalc after a short delay */
    setTimeout(function () {
      recalc();
      onScroll();
    }, 500);

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener(
      "resize",
      function () {
        recalc();
        requestAnimationFrame(onScroll);
      },
      { passive: true },
    );

    /* ---- dot clicks: scroll to the panel's position in the spacer ---- */
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        var target = sectionDocTop + (i / numPanels) * total;
        window.scrollTo({ top: target, behavior: "smooth" });
      });
    });

    /* ---- Snap-scroll: one wheel tick / one swipe = one panel ---- */
    function snapToPanel(newIndex) {
      if (snapBusy) return;
      snapBusy = true;
      /* Scroll to just inside the start of that panel's range */
      var step = total / numPanels;
      window.scrollTo({ top: sectionDocTop + newIndex * step + 1, behavior: "smooth" });
      setTimeout(function () { snapBusy = false; }, 800);
    }

    /* Desktop — wheel events */
    window.addEventListener("wheel", function (e) {
      if (!stickyFixed) return;
      var dir = e.deltaY > 0 ? 1 : -1;
      var next = activeIdx + dir;
      /* At the first/last panel let scroll escape naturally */
      if (next < 0 || next >= numPanels) return;
      e.preventDefault();
      snapToPanel(next);
    }, { passive: false });

    /* Mobile — touch swipe on the sticky viewport */
    var touchY0 = 0;
    var touchX0 = 0;
    sticky.addEventListener("touchstart", function (e) {
      touchY0 = e.changedTouches[0].clientY;
      touchX0 = e.changedTouches[0].clientX;
    }, { passive: true });
    sticky.addEventListener("touchend", function (e) {
      if (!stickyFixed) return;
      var dy = touchY0 - e.changedTouches[0].clientY;
      var dx = touchX0 - e.changedTouches[0].clientX;
      /* Ignore taps and horizontal swipes */
      if (Math.abs(dy) < 40 || Math.abs(dx) > Math.abs(dy)) return;
      var next = activeIdx + (dy > 0 ? 1 : -1);
      if (next < 0 || next >= numPanels) return;
      snapToPanel(next);
    }, { passive: true });
  }
  /* ================================================================
     6. TESTIMONIAL SLIDER
     Desktop: 3 cards side-by-side (no JS needed).
     Mobile (<768px): one card visible, track translates on nav.
     ================================================================ */

  function initSlider() {
    // var track = document.getElementById("reviews-track");
    var track = document.querySelector(".slider-track");
    var prevBtn = document.querySelector(".slider-btn--prev");
    var nextBtn = document.querySelector(".slider-btn--next");
    var dotsContainer = document.querySelector(".slider-dots");

    if (!track) return;

    var slides = track.querySelectorAll(".slider-slide");
    var numSlides = slides.length; /* 6 individual cards */
    var current = 0;

    function isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    }

    /* Desktop: 2 pages of 3; Mobile: 6 individual cards */
    function getTotal() {
      return isMobile() ? numSlides : Math.ceil(numSlides / 3);
    }

    function buildDots() {
      var total = getTotal();
      dotsContainer.innerHTML = "";
      for (var i = 0; i < total; i++) {
        var dot = document.createElement("button");
        dot.className = "slider-dot" + (i === 0 ? " slider-dot--active" : "");
        dot.setAttribute("role", "tab");
        dot.setAttribute("aria-selected", i === 0 ? "true" : "false");
        dot.setAttribute("aria-label", "Go to slide " + (i + 1));
        (function (idx) {
          dot.addEventListener("click", function () { goTo(idx); });
        })(i);
        dotsContainer.appendChild(dot);
      }
    }

    function goTo(index) {
      var total = getTotal();
      current = (index + total) % total;
      /* translateX(-N * 100%) always moves exactly N container widths.
         Desktop: page N = cards 3N…3N+2 which start at N × 100% of track.
         Mobile: card N starts at N × 100% of track. Same formula either way. */
      track.style.transform = "translateX(-" + current * 100 + "%)";
      dotsContainer.querySelectorAll(".slider-dot").forEach(function (d, i) {
        d.classList.toggle("slider-dot--active", i === current);
        d.setAttribute("aria-selected", String(i === current));
      });
    }

    buildDots();
    goTo(0);

    if (prevBtn) prevBtn.addEventListener("click", function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { goTo(current + 1); });

    /* touch swipe */
    var startX = 0;
    track.addEventListener("touchstart", function (e) {
      startX = e.changedTouches[0].clientX;
    }, { passive: true });
    track.addEventListener("touchend", function (e) {
      var delta = e.changedTouches[0].clientX - startX;
      if (Math.abs(delta) > 40) goTo(delta < 0 ? current + 1 : current - 1);
    }, { passive: true });

    /* Rebuild dots if breakpoint crosses 768px */
    var wasM = isMobile();
    window.addEventListener("resize", function () {
      var isM = isMobile();
      if (isM !== wasM) {
        wasM = isM;
        current = 0;
        buildDots();
        goTo(0);
      }
    }, { passive: true });
  }


  /* ================================================================
     9. MANIFESTO SCROLL REVEAL — GSAP + ScrollTrigger
     ================================================================ */

  function initManifestoReveal() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

    gsap.registerPlugin(ScrollTrigger);

    var section = document.getElementById("manifesto");
    if (!section) return;

    /* Split an element's text into <span class="word"> per word,
       keeping whitespace nodes between them as plain text. */
    function splitIntoWords(el) {
      var text = el.textContent || "";
      var parts = text.split(/(\s+)/);
      el.innerHTML = parts
        .map(function (part) {
          if (/^\s+$/.test(part)) return part;
          return '<span class="sr-word">' + part + "</span>";
        })
        .join("");
      return el.querySelectorAll(".sr-word");
    }

    var eyebrow = section.querySelector(".manifesto__eyebrow");
    var paragraphs = section.querySelectorAll(".manifesto__text");
    var cta = section.querySelector(".cta-group");
    var content = section.querySelector(".manifesto__content");

    /* ---- LAYER 1: Fade-in-up — fires once when section enters view ---- */
    var fadeTargets = [];
    if (eyebrow) fadeTargets.push(eyebrow);
    paragraphs.forEach(function (p) {
      fadeTargets.push(p);
    });
    if (cta) fadeTargets.push(cta);

    gsap.from(fadeTargets, {
      y: 55,
      opacity: 0,
      duration: 0.9,
      ease: "power3.out",
      stagger: 0.16,
      scrollTrigger: {
        trigger: section,
        start: "top 50%",
        once: true,
      },
    });

    /* ---- LAYER 2: Word-level blur + rotation scrub (opacity stays 1 after fade-in) ---- */
    function applyWordScrub(el, opts) {
  var blurStrength = opts.blurStrength !== undefined ? opts.blurStrength : 0; //4

  var words = splitIntoWords(el);

  /* blur scrub on words */
  gsap.fromTo(
    words,
    { filter: "blur(" + blurStrength + "px)" },
    {
      ease: "none",
      filter: "blur(0px)",
      stagger: 0.05,
      scrollTrigger: {
        trigger: el,
        start: "top center",
        end: "bottom center",
        scrub: true,
      },
    }
  );
}

    if (eyebrow) {
      applyWordScrub(eyebrow, { blurStrength: 0 }); //4
    }

    paragraphs.forEach(function (p) {
      applyWordScrub(p, { blurStrength: 0 }); //3
    });
  }
/* ================================================================
     10. HOW-IT-WORKS STEP PROGRESS NAV
     Highlights the active step dot as each section crosses the
     vertical midpoint of the viewport.
     Runs only on pages that have .gs-progress__step elements.
     ================================================================ */

  function initStepProgress() {
    var steps = document.querySelectorAll("[id^='step-']");
    var links = document.querySelectorAll(".gs-progress__step");
    if (!steps.length || !links.length) return;

    /* Active step highlight */
    function setActive(id) {
      links.forEach(function (link) {
        link.classList.toggle("gs-progress__step--active", link.getAttribute("href") === "#" + id);
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) setActive(entry.target.id);
      });
    }, { rootMargin: "-45% 0px -45% 0px", threshold: 0 });

    steps.forEach(function (el) { observer.observe(el); });

    /* Header hide-on-scroll so gs-progress has no gap.
       Toggles body.header-hidden which CSS already handles.
       On Shopify, MutationObserver in initStickyHeader also sets the same
       class, so both paths are safe to run together. */
    var lastY = window.scrollY;
    var hideThreshold = 80;
    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      if (y < hideThreshold) {
        document.body.classList.remove("header-hidden");
      } else if (y > lastY) {
        document.body.classList.add("header-hidden");
      } else {
        document.body.classList.remove("header-hidden");
      }
      lastY = y;
    }, { passive: true });
  }
  /* ================================================================
   11. PREMIUM VIDEO SECTION
   ================================================================ */

function initPremiumVideo() {

  var video = document.getElementById("premiumVideo");
  var button = document.getElementById("videoToggle");

  if (!video || !button) return;

  var tooltip = button.querySelector(".video-tooltip");

  button.addEventListener("click", function () {

    if (video.paused) {

      video.play();

      button.classList.add("is-playing");

      if (tooltip) {
        tooltip.textContent = "Stop Video";
      }

      button.setAttribute(
        "aria-label",
        "Pause Video"
      );

    } else {

      video.pause();

      button.classList.remove("is-playing");

      if (tooltip) {
        tooltip.textContent = "Start Video";
      }

      button.setAttribute(
        "aria-label",
        "Play Video"
      );
    }
  });

  video.addEventListener("ended", function () {

    button.classList.remove("is-playing");

    if (tooltip) {
      tooltip.textContent = "Start Video";
    }

    button.setAttribute(
      "aria-label",
      "Play Video"
    );
  });

}
/* ================================================================
     12. REVIEWS PAGE — LOAD MORE
     Shows 12 review cards at a time; hides the rest until Load More
     is clicked. Falls back gracefully if the page has no rv-grid.
     ================================================================ */

  function initReviewsPage() {
    var grid = document.getElementById("rv-grid");
    var loadBtn = document.getElementById("rv-load-btn");
    var loadWrap = document.getElementById("rv-load");
    var countEl = document.getElementById("rv-count");
    if (!grid || !loadBtn) return;

    var allCards = grid.querySelectorAll(".review-card");
    if (!allCards.length) return;

    var batchSize = 12;
    var shown = 0;

    function showBatch() {
  var end = Math.min(shown + batchSize, allCards.length);
  for (var i = shown; i < end; i++) {
    allCards[i].classList.remove("rv-hidden");
  }
  shown = end;
  if (countEl) {
    countEl.textContent = "Showing " + shown + " of " + allCards.length + " reviews";
  }
  if (shown >= allCards.length && loadWrap) {
    loadWrap.classList.add("rv-hidden");
  }
}

allCards.forEach(function (card) {
  card.classList.add("rv-hidden");
});

showBatch();
loadBtn.addEventListener("click", showBatch);


  
  }
  /* ================================================================
     13. BROKEN IMAGE FALLBACK
     Adds .img-error so CSS can hide the broken icon and let the
     parent placeholder background show through.
     ================================================================ */

  function initImageFallbacks() {
    document.querySelectorAll("img").forEach(function (img) {
      if (img.complete && img.naturalWidth === 0) {
        img.classList.add("img-error");
      }
      img.addEventListener("error", function () {
        img.classList.add("img-error");
      });
    });
  }

/* ================================================================
   14. GLOBAL GORGIAS LIVE CHAT TRIGGER
   Any element with [data-open-chat] opens the Gorgias chat.
   ================================================================ */

function initLiveChatTrigger() {
  document.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-open-chat]");

    if (!trigger) return;

    event.preventDefault();

    // Preferred: Gorgias Chat API
    if (window.GorgiasChat && typeof window.GorgiasChat.open === "function") {
      window.GorgiasChat.open();
      return;
    }

    // Fallback: click the Gorgias launcher
    var chatButton = document.getElementById(
      "gorgias-chat-messenger-button"
    );

    if (chatButton) {
      chatButton.click();
    } else {
      console.warn("Gorgias chat is not ready yet.");
    }
  });
}

/* ================================================================
   15. GLOBAL GORGIAS LIVE CHAT TRIGGER
   Any element with [data-open-chat] opens the Gorgias chat.
   ================================================================ */
function addDeliveryShippingNotice() {
  var billingText =
    "This will also be used as your billing address for this order.";

  var shippingText =
    "We currently ship within the U.S. only. For international delivery inquiries, please provide your email address and phone number, and our team will contact you with available options.";

  function insertNotice() {
    var heading = document.getElementById("deliveryAddress");

    if (!heading) return;

    // Prevent duplicate insertion
    if (document.getElementById("custom-delivery-notices")) {
      return;
    }

    // Wrapper
    var wrapper = document.createElement("div");
    wrapper.id = "custom-delivery-notices";

    // Billing text
    var billing = document.createElement("p");
    billing.className = "custom-billing-notice";
    billing.textContent = billingText;

    // International shipping text
    var shipping = document.createElement("p");
    shipping.className = "custom-international-shipping-notice";
    shipping.textContent = shippingText;

    // Add both
    wrapper.appendChild(billing);
    wrapper.appendChild(shipping);

    // Insert directly below Delivery heading
    heading.insertAdjacentElement("afterend", wrapper);
  }

  // Initial check
  insertNotice();

  // Shopify Checkout dynamically renders content
  var observer = new MutationObserver(function () {
    insertNotice();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

  /* ================================================================
     INIT
     ================================================================ */

  function init() {
    initScrollReveal();
    initHeroVideo();
    initScrollFeatures();
    initSlider();
    initStepProgress();
    initReviewsPage();
    initImageFallbacks();
    initManifestoReveal();
    initPremiumVideo();
    initLiveChatTrigger();

    addDeliveryShippingNotice();
  }

  if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}

  /* Shopify theme JS shifts layout after load — refresh GSAP measurements */
  window.addEventListener('load', function () {
    if (typeof ScrollTrigger !== 'undefined') {
      setTimeout(function () { ScrollTrigger.refresh(); }, 400);
    }
  });
})();
